import React from 'react';
import PropTypes from 'prop-types';
import { Form, InputGroup } from 'react-bootstrap';

// import { getSomething } from '../../../api/Layers/layer-operations';
import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';

// FIXME: this props will be needed: layer
const LayerUploadFileField = ({ layerSubType }) => {
  if (LAYER_SUBTYPES.UPLOADED_FILE === layerSubType) {
    return (
      <InputGroup>
        <div className="custom-file">
          <Form.Control
            type="file"
            name="file"
            className="custom-file-input"
            id="inputFile"
            aria-describedby="inputFile"
            defaultValue=""
          />
          <Form.Label className="custom-file-label" htmlFor="inputFile">
            Upload File
          </Form.Label>
        </div>
      </InputGroup>
    );
  }
  return '';
};
LayerUploadFileField.propTypes = {
  layer: PropTypes.object.isRequired,
  layerSubType: PropTypes.string.isRequired
};

export default LayerUploadFileField;
